import { Box, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Translate as T } from "react-localize-redux";
import { Trash2 } from "react-feather";
var useStyles = makeStyles(function (theme) { return ({
    arrow: {
        color: "#6D7781",
    },
    card: {
        "&:hover": {
            borderBottom: "1px solid #FFF",
            borderTop: "1px solid #FFF",
            boxShadow: "0px 7px 14px rgba(60, 66, 87, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.12)",
            cursor: "pointer",
        },
        alignItems: "center",
        background: "#FFFFFF",
        border: "2px solid #CBD5E0",
        borderRadius: "4px",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2.5),
        minHeight: theme.spacing(5),
        padding: theme.spacing(1.5),
        paddingLeft: 0,
        transition: "box-shadow 0.25s, border 0.25s",
    },
    description: {
        color: "#6D7781",
        fontSize: "12px",
        marginTop: theme.spacing(0.5),
    },
    logo: {
        height: "auto",
        width: theme.spacing(5.5),
        maxHeight: theme.spacing(3.5),
        maxWidth: theme.spacing(5.5),
    },
    logoContainer: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        width: theme.spacing(10),
    },
}); });
export var CardItem = function (_a) {
    var title = _a.title, description = _a.description, Logo = _a.logo, handlerOnClick = _a.handlerOnClick, isEdit = _a.isEdit, isKpay = _a.isKpay;
    var classes = useStyles();
    return (React.createElement(Box, { className: classes.card, onClick: function () { return handlerOnClick(); } },
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement("div", null,
                React.createElement(Box, { className: classes.logoContainer },
                    React.createElement(Logo, { className: classes.logo }))),
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h6" }, isKpay ? title : React.createElement(T, { id: title })),
                React.createElement(Typography, { className: classes.description }, isKpay ? description : React.createElement(T, { id: description })))),
        isEdit ? React.createElement(Trash2, null) : React.createElement(ChevronRightIcon, { className: classes.arrow })));
};
export default CardItem;
